export const initNav = () => {
    var menuToggleList = document.getElementsByClassName('menu-toggle');
    const menu = document.querySelector('.menu');
    const primaryNavigation = document.querySelector('.primary-navigation');
    const mobileMenu = document.querySelector('.menu--mobile');


    if (menuToggleList && primaryNavigation) {

        //console.log("menu exists");
        for (var i = 0; i < menuToggleList.length; i++)
            menuToggleList[i].addEventListener('click', function () {
                primaryNavigation.classList.toggle('expanded');
                menu.classList.toggle('open');
                mobileMenu.classList.toggle('open');
                document.body.classList.toggle('hidden-overflow');
            });
    }
};
